import {FORGOT_PASSWORD_SUCCESS,FORGOT_PASSWORD_ERROR} from '../actions/actiontypes';

export default function(state='',action){
  switch(action.type){
    case FORGOT_PASSWORD_ERROR : {
      return {...state,error:action.payload,success:undefined};
    }
    case FORGOT_PASSWORD_SUCCESS : {
      return {...state,success:action.payload,error:undefined}
    }
    default:
			return state;
  }
}